import { RemirrorJSON } from 'remirror';

export const EmptyRemirrorJson = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
      // using this format so we can still type in the editor when this is the initial state
      content: [],
    },
  ],
};

export function stringToRemirrorJson(text: string) {
  const json = {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        attrs: {
          nodeIndent: null,
          nodeTextAlignment: null,
          nodeLineHeight: null,
          style: '',
        },
        content: [{ type: 'text', text }],
      },
    ],
  };
  return json;
}

export function isEmptyMessage(message?: RemirrorJSON): boolean {
  if (!message?.content?.length) {
    return true;
  }

  if (message === EmptyRemirrorJson) {
    return true;
  }

  return message.content.every(({ content }) => !content);
}
